export class Login {
    mobile:string="";
    password:string="";
}
